<template>
    <section class="block-contacts contacts container_wide" id="contacts">
        <section class="contacts__details">
            <h2 class="contacts__title">Контакты</h2>
            <section class="contacts__address-container">
                <img class="contacts__icon" src="../images/map-icon.svg" alt="" />
                <p class="contacts__address">{{ CONSTANTS.address }}</p>
            </section>
            <section class="contacts__phone-container">
                <img class="contacts__icon" src="../images/phone-icon.svg" alt="" />
                <a class="comagic_phone2" :href="`tel:${CONSTANTS.phone_raw}`">{{ CONSTANTS.phone }}</a>
            </section>
            <section class="contacts__worktime-container">
                <img class="contacts__icon" src="../images/clock-icon.svg" alt="" />
                <ul class="contacts__worktimes">
                    <!--<li
                        class="contacts__worktime"
                        v-for="(worktime, i) in CONSTANTS.worktimes"
                        :key="`worktime-${i}`"
                    >
                        {{ worktime }}
                    </li>-->
                    <li
                        class="contacts__worktime"
                    >
                        {{ CONSTANTS.worktimes[0] }}
                    </li>
                </ul>
            </section>
            <button class="contacts__button">
                <a class="contacts__button-text" href="https://yandex.ru/maps/213/moscow/?ll=37.784290%2C55.816197&mode=routes&rtext=~55.816197%2C37.784291&rtt=auto&ruri=~ymapsbm1%3A%2F%2Fgeo%3Fdata%3DCgg1Njc2NDc3OBJB0KDQvtGB0YHQuNGPLCDQnNC-0YHQutCy0LAsINCY0YDQutGD0YLRgdC60LDRjyDRg9C70LjRhtCwLCA1LzbRgTEiCg0dIxdCFclDX0I%2C&z=16.62" target="_blank" rel="noopener noreferrer">Построить маршрут</a>
                <img src="../images/chevron-right.svg" alt="">
            </button>
        </section>
        <div id="ya-karto"></div>
    </section>
</template>

<script>
import Mask from "../common/mask";
import Mixin from "../common/mixin";
import Keyup from "../common/keyup";
import CallbackForm from "./callback-form";

export default {
  name: "",
  components: { CallbackForm },
  directives: { Mask, Keyup },
  mixins: [Mixin],
  props: [""],
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(this.waitYmaps);
  },
  computed: {},
  methods: {
    initYandexMap() {
      const isMobile = {
        Android: function() {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
          return navigator.userAgent.match(/IEMobile/i);
        },
        any: function() {
          return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
          );
        },
      };
      let zoomControl = new ymaps.control.ZoomControl({
        options: {
          position: {
            left: "auto",
            right: 10,
            top: 108,
          },
        },
      });
      let center_x =
        this.device_platform === "phone"
          ? this.CONSTANTS.coords.x_center_small
          : this.CONSTANTS.coords.x_center_big;

      let myMap = new ymaps.Map(
        "ya-karto",
        {
          center: [this.CONSTANTS.coords.y_center, center_x],
          zoom: 16,
          controls: [],
        },
        {
          searchControlProvider: "yandex#search",
        }
      );
      myMap.controls.add(zoomControl);

      myMap.geoObjects.add(
        new ymaps.Placemark(
          [this.CONSTANTS.coords.y_salon, this.CONSTANTS.coords.x_salon],
          {
            iconContent: this.CONSTANTS.salon_name,
          },
          {
            preset: "islands#blueStretchyIcon",
            iconColor: "#1e98ff",
          }
        )
      );
      if (isMobile.any() || this.device_platform !== "desktop") {
        myMap.behaviors.disable("drag");
      }
      myMap.behaviors.disable("scrollZoom");
    },
    waitYmaps() {
      let script = document.createElement("script");
      script.src = "//api-maps.yandex.ru/2.1/?load=package.standard&lang=ru_RU";
      document.head.appendChild(script);
      script.onload = () => {
        ymaps.ready(this.initYandexMap);
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

$details-width: 400px;

.contacts {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 100px 20px 60px;

  &__details {
    width: $details-width;
    padding-right: 40px;
  }

  &__title {
    margin-bottom: 45px;
    font-size: 30px;
    text-transform: uppercase;
  }

  &__worktimes {
    position: relative;
    top: -7px;
    list-style-type: none;
  }

  &__address {
    position: relative;
    top: -4px;
  }

  &__address-container,
  &__phone-container,
  &__worktime-container {
    display: flex;
    margin-bottom: 40px;
    font-size: 18px;
  }

  &__address-container,
  &__worktime-container {
    align-items: flex-start;
  }

  &__worktime-container {
    margin-bottom: 78px;
  }

  &__phone-container {
    font-weight: 700;
  }

  &__icon {
    margin-right: 15px;
  }

  &__button {
    display: flex;
    align-items: center;
    border: 0;
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
    background: transparent;
    text-transform: uppercase;
    cursor: pointer;
  }

  &__button-text {
    margin-right: 10px;
  }

  & #ya-karto {
    width: calc(100% - $details-width);
    height: 377px;
  }
}

@media (max-width: 1600px) {
  .contacts {
    padding-right: 0;
  }
}

@media (max-width: 800px) {
  .contacts {
    &__details {
      width: calc($details-width - 40px);
    }

    & #ya-karto {
      width: calc(100% - ($details-width - 40px));
    }
  }
}

@media (max-width: 750px) {
  .contacts {
    flex-direction: column;
    padding-left: 0;
    padding-bottom: 0;

    &__details {
      margin-bottom: 30px;
      padding-left: 20px;
    }

    &__title {
      margin-bottom: 25px;
    }

    &__address-container,
    &__phone-container,
    &__worktime-container {
      margin-bottom: 20px;
    }

    & #ya-karto {
      width: 100%;
      height: 240px;
    }
  }
}
</style>
